<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.account_event"
        :filters.sync="filters"
        @apply="reload"
        @ready="load"
      />

      <el-card
        v-loading="isLoadingEvents"
        shadow="never"
      >
        <EventsTable
          :columns="[ 'peek', 'task', 'due', 'priority', 'actions' ]"
          :events.sync="events"
        >
          <template v-slot:peek="{ event }">
            <EventPeek :event="event" />
          </template>
        </EventsTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="events.page"
          :page-size.sync="events.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="events.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Complex'
import EventsTable from '@/components/Application/Sales/Events/Table'
import EventPeek from '@/components/Application/Sales/Events/Event/Peek'
import { CREATED, UPDATED, DELETED, RESTORED } from '@/plugins/sdk/Events'

export default {
  components: {
    Filters,
    EventsTable,
    EventPeek
  },
  data () {
    return {
      breadcrumb: {
        name: 'To-Do',
        route: { name: 'sales-accounts-account-todo', params: { accountId: this.$route.params.accountId } }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoadingEvents: true,
      events: [],
      filters: []
    }
  },
  mounted () {
    this
      .$sdk
      .account_event
      .on([ CREATED, UPDATED, DELETED, RESTORED ], this.reload, this)
  },
  methods: {
    load () {
      this
        .$sdk
        .account_event
        .list(builder => {
          builder.context = { resource: this.$sdk.account.name, identifier: this.$route.params.accountId }
          builder.include = [ 'type', 'notes' ]
          builder.filters = this.filters
        })
        .then(res => { this.events = res })
        .finally(() => { this.isLoadingEvents = false })
    },
    async reload () {
      this.isLoadingEvents = true

      try {
        await this.events.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('Failed to load Events')
      }

      this.isLoadingEvents = false
    }
  }
}
</script>
